import FreeAccountCreate from '@containers/account/FreeAccountCreate';

const FreeAccountCreatePage = () => {
  return <FreeAccountCreate />;
};

export default FreeAccountCreatePage;
